/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 15:09:16
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/LongCanvas.ts
 */
import { ActionType } from 'src/types/common/common';
import { generateLinkImg } from 'src/constrains/DraggableModules/tools';
import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   LongCanvas,
  //   ProductGridDisplay,
  LongCanvas,
  //   ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const LongCanvasFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnLongCanvasItemAdd = (id) => {
    const _o = generateLinkImg(1);
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: _o });
    }
  };

  const handleOnLongCanvasItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnLongCanvasItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };

  const handleOnLongCanvasItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };
  return {
    handleOnLongCanvasItemAdd,
    handleOnLongCanvasItemChange,
    handleOnLongCanvasItemSort,
    handleOnLongCanvasItemDelete,

    //  handleOnLongCanvasModuleTypeChange,
  };
};
const generateLongCanvas = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  disabled,
  allDisabled,
  hideEdit,
}) => {
  const {
    handleOnLongCanvasItemAdd,
    handleOnLongCanvasItemChange,
    handleOnLongCanvasItemSort,
    handleOnLongCanvasItemDelete,
  } = LongCanvasFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: LongCanvas,
    props: {
      onItemAdd: handleOnLongCanvasItemAdd,
      onItemChange: handleOnLongCanvasItemChange,
      onItemSort: handleOnLongCanvasItemSort,
      onItemDelete: handleOnLongCanvasItemDelete,
      disabled,
      allDisabled,
      hideEdit,
    },
  };
};
export { generateLongCanvas };
